import { render, staticRenderFns } from "./socialLink.vue?vue&type=template&id=8f526adc&"
import script from "./socialLink.vue?vue&type=script&lang=js&"
export * from "./socialLink.vue?vue&type=script&lang=js&"
import style0 from "./socialLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports